/* unplugin-vue-components disabled */import { render } from "./Cell.vue?vue&type=template&id=a8469270&scoped=true&ts=true"
import script from "./Cell.vue?vue&type=script&lang=ts"
export * from "./Cell.vue?vue&type=script&lang=ts"

import "./Cell.vue?vue&type=style&index=0&id=a8469270&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8469270"]])

export default __exports__